module.exports = __webpack_public_path__ + "c04d1d6569c6e0f5b042660dee1d4ade.svg";